var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "#66BB6A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50005 0C3.36455 0 0 3.36454 0 7.5C0 11.6355 3.36455 15 7.50005 15C11.6355 15 15 11.6355 15 7.5C15 3.36454 11.6355 0 7.50005 0ZM11.6572 5.97195L6.86725 10.7619C6.72148 10.9077 6.51942 10.9913 6.31331 10.9913V11.3157L6.30634 10.9913C6.09747 10.9896 5.89461 10.9023 5.74963 10.752L3.33309 8.24727C3.03309 7.93636 3.04201 7.4397 3.35287 7.1397C3.49963 6.99796 3.69276 6.92012 3.8966 6.92012C4.11114 6.92012 4.31142 7.00511 4.46044 7.15945L6.32337 9.09037L10.5497 4.86422C10.6975 4.71633 10.8943 4.63476 11.1036 4.63476C11.3128 4.63476 11.5095 4.71616 11.6574 4.86406C11.9625 5.16957 11.9625 5.6666 11.6572 5.97195Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ed49abdec6184ae2cc9317b919cb0dee.svg";
export { ForwardRef as ReactComponent };